var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var assertVideoTranscodeSupported = function () {
    if (typeof window === 'undefined') {
        throw new Error('Video transcoding is not supported in this environment');
    }
    if (!window.VideoEncoder || !window.AudioEncoder) {
        throw new Error('Video transcoding is not supported in this browser');
    }
};
var createUploadStoppedError = function () {
    var error = new Error('Upload stopped');
    error.code = 'UPLOAD_STOPPED';
    return error;
};
var ensureActive = function (stopRequested) {
    if (stopRequested()) {
        throw createUploadStoppedError();
    }
};
var loadMediaBunny = function () {
    return Promise.resolve(require('mediabunny'));
};
var createMp4Output = function (mediaBunny) {
    var target = new mediaBunny.BufferTarget();
    var output = new mediaBunny.Output({
        format: new mediaBunny.Mp4OutputFormat(),
        target: target
    });
    return { output: output, target: target };
};
export function transcodeVideoForUpload(options) {
    return __awaiter(this, void 0, void 0, function () {
        var meta, targetConfig, mediaBunny, ALL_FORMATS, BlobSource, Conversion, Input, input, _a, output, target, conversion, error_1, mimeType, buffer, fileName, file;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ensureActive(options.stopRequested);
                    assertVideoTranscodeSupported();
                    options.onProgress({ stage: 'analyze', progress: 5 });
                    return [4 /*yield*/, getVideoMetadata(options.file)];
                case 1:
                    meta = _b.sent();
                    ensureActive(options.stopRequested);
                    targetConfig = getVideoTargetConfig(meta);
                    return [4 /*yield*/, loadMediaBunny()];
                case 2:
                    mediaBunny = _b.sent();
                    ALL_FORMATS = mediaBunny.ALL_FORMATS, BlobSource = mediaBunny.BlobSource, Conversion = mediaBunny.Conversion, Input = mediaBunny.Input;
                    ensureActive(options.stopRequested);
                    input = new Input({
                        source: new BlobSource(options.file),
                        formats: ALL_FORMATS
                    });
                    _a = createMp4Output(mediaBunny), output = _a.output, target = _a.target;
                    return [4 /*yield*/, Conversion.init({
                            input: input,
                            output: output,
                            tracks: 'primary',
                            showWarnings: false,
                            video: {
                                codec: 'avc',
                                bitrate: targetConfig.bitrate,
                                frameRate: targetConfig.frameRate,
                                width: targetConfig.width,
                                height: targetConfig.height,
                                fit: 'contain',
                                keyFrameInterval: meta.duration > 30 ? 5 : 2,
                                hardwareAcceleration: 'no-preference',
                                forceTranscode: true
                            },
                            audio: {
                                codec: 'aac',
                                bitrate: 128000,
                                forceTranscode: true
                            }
                        })];
                case 3:
                    conversion = _b.sent();
                    if (!conversion.isValid) {
                        throw new Error('Video transcoding is not supported in this browser for the selected codec or media');
                    }
                    options.onProgress({
                        stage: 'transcode',
                        progress: 10
                    });
                    conversion.onProgress = function (progress) {
                        if (options.stopRequested()) {
                            void conversion.cancel();
                            return;
                        }
                        var scaledProgress = Math.round((10 + Math.max(0, Math.min(progress, 1)) * 85) * 100) / 100;
                        options.onProgress({
                            stage: 'transcode',
                            progress: scaledProgress
                        });
                    };
                    _b.label = 4;
                case 4:
                    _b.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, conversion.execute()];
                case 5:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _b.sent();
                    if (options.stopRequested()) {
                        throw createUploadStoppedError();
                    }
                    throw error_1;
                case 7:
                    ensureActive(options.stopRequested);
                    options.onProgress({ stage: 'finalize', progress: 95 });
                    return [4 /*yield*/, output.getMimeType()];
                case 8:
                    mimeType = (_b.sent()) || 'video/mp4';
                    buffer = target.buffer;
                    if (!buffer) {
                        throw new Error('Video transcoding did not produce an output buffer');
                    }
                    fileName = replaceFileExtension(options.file.name, '.mp4');
                    file = new File([buffer], fileName, {
                        type: mimeType || 'video/mp4',
                        lastModified: Date.now()
                    });
                    return [2 /*return*/, {
                            file: file,
                            mimeType: mimeType || 'video/mp4'
                        }];
            }
        });
    });
}
export function getVideoMetadata(file) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var objectUrl = URL.createObjectURL(file);
                    var video = document.createElement('video');
                    video.preload = 'metadata';
                    video.src = objectUrl;
                    video.onloadedmetadata = function () {
                        var width = video.videoWidth || 1280;
                        var height = video.videoHeight || 720;
                        var duration = video.duration || 1;
                        URL.revokeObjectURL(objectUrl);
                        resolve({
                            width: width,
                            height: height,
                            duration: duration,
                            frameRate: 30
                        });
                    };
                    video.onerror = function () {
                        URL.revokeObjectURL(objectUrl);
                        reject(new Error('Unable to read video metadata'));
                    };
                })];
        });
    });
}
var getTargetVideoSize = function (width, height) {
    var maxWidth = 1280;
    var maxHeight = 720;
    var ratio = Math.min(maxWidth / width, maxHeight / height, 1);
    return {
        width: Math.max(2, Math.floor((width * ratio) / 2) * 2),
        height: Math.max(2, Math.floor((height * ratio) / 2) * 2)
    };
};
var getTargetVideoBitrate = function (width, height) {
    var pixels = width * height;
    if (pixels >= 1280 * 720)
        return 2000000;
    if (pixels >= 960 * 540)
        return 1500000;
    return 1000000;
};
var getTargetFrameRate = function (frameRate) {
    var normalizedFrameRate = Math.round(frameRate || 30);
    return Math.max(1, Math.min(normalizedFrameRate, 30));
};
var getVideoTargetConfig = function (meta) {
    var size = getTargetVideoSize(meta.width, meta.height);
    return {
        width: size.width,
        height: size.height,
        bitrate: getTargetVideoBitrate(size.width, size.height),
        frameRate: getTargetFrameRate(meta.frameRate)
    };
};
var replaceFileExtension = function (fileName, extension) {
    var lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex <= 0) {
        return "".concat(fileName).concat(extension);
    }
    return "".concat(fileName.slice(0, lastDotIndex)).concat(extension);
};
